export default class CommonInterface {
  constructor(common) {
    this.clientId = common.clientId;
    this.eventDate = common.eventDate ?? Date.now();
    this.eventsType = common.eventsType ?? [];
    this.defaultType = common.defaultType ?? '';
    this.langList = common.langList ?? ['pl'];
    this.isNewSender = common.isNewSender ?? true;
  }
}
